<template>
  <ion-app>
    <ion-router-outlet />
  </ion-app>
</template>

<script>
import {IonApp, IonRouterOutlet} from '@ionic/vue';
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'Salon2026',
  components: {
    IonApp,
    IonRouterOutlet
  }
});
</script>
